import { render, staticRenderFns } from "./confirmOrder.vue?vue&type=template&id=b093a10c&scoped=true"
import script from "./confirmOrder.vue?vue&type=script&lang=js"
export * from "./confirmOrder.vue?vue&type=script&lang=js"
import style0 from "./confirmOrder.vue?vue&type=style&index=0&id=b093a10c&prod&lang=css"
import style1 from "./confirmOrder.vue?vue&type=style&index=1&id=b093a10c&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b093a10c",
  null
  
)

export default component.exports